import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ModalController, AlertController, NavParams, Platform } from '@ionic/angular';
import { PlanoDialogViewModel } from './PlanoDialogViewModel';
import { BaseDialog } from 'src/pages/base.dialog';
import { AlertComponent } from 'projects/core/src/lib/core/Alert.component';
import { Browser } from '@capacitor/browser';

@Component({
  selector: 'plano-dialog',
  templateUrl: 'plano.dialog.html',
  styleUrls: ['plano.dialog.scss']
})
export class PlanoDialog extends BaseDialog {

  constructor(
    public router: Router, 
    public modalCtrl: ModalController,
    public alertController: AlertController,
    public params: NavParams,
    private platform: Platform){
      super(modalCtrl, router)
  }

  planoDialogViewModel: PlanoDialogViewModel
  alertComponent: AlertComponent
  mensagem = ""

  ngOnInit() {
    this.iniciaVariaveis()
    this.ajustaAlturaDialog()

    if (this.platform.is("ios")) {
      this.mensagem = "<strong>Olá</strong>, essa funcionalidade está disponível para usuários premium. Por favor, caso queira ser premium, clique abaixo para contratação."
    } else {
      this.mensagem = "Essa funcionalidade está disponível apenas para usuários Premium. Clique abaixo para atualizar agora."
    }
  }

  iniciaVariaveis() {
    this.planoDialogViewModel = new PlanoDialogViewModel()
    this.planoDialogViewModel.setContext(this)
  }

  ajustaAlturaDialog() {
    let el: HTMLElement = document.querySelector(".modal-wrapper")
    el.style.maxHeight = "360px"
  }

  clickAtualizar() {
    this.closeDialog()
    if (this.platform.is("ios")) {
      this.openPage("plano-ios")
    } else {
      this.abreLinkExterno(this.params.get('urlContratar'))
    }
  }

  async abreLinkExterno(url: string) {
    await Browser.open({ url });
  }
}
